import React from 'react';
import { GTM_ID } from '../../../../../common/constants/gtmIds';
import { MobileMenuLanguageButtonProps } from './mobile-menu-language-button.types';
import {
  StyledExternalLink,
  StyledLink,
} from './mobile-menu-languages-button.styles';
import { WrapperProps } from '../navbar-atoms-common.types';

const Wrapper: React.FC<WrapperProps> = ({
  isExternal,
  link,
  children,
  gtmId,
}) => {
  if (isExternal) {
    return (
      <StyledExternalLink
        href={link}
        data-gtm-id={gtmId}
        target="_blank"
        rel="noreferrer noopener"
      >
        {children}
      </StyledExternalLink>
    );
  }
  return (
    <StyledLink to={link || ''} data-gtm-id={gtmId}>
      {children}
    </StyledLink>
  );
};

export const MobileMenuLanguageButton: React.FC<
  MobileMenuLanguageButtonProps
> = ({ language }) => (
  <Wrapper
    isExternal={language.link.isExternal}
    link={language.link.path}
    gtmId={`${GTM_ID.FLYOVER_LINK_COLUMN}1`}
  >
    <span>{language.title}</span>
  </Wrapper>
);
